import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

const Base = styled.div<{ selected: boolean; highlighted: boolean }>`
  font-weight: ${p => select.fontWeight(p.selected ? "bold" : "normal", p)};
  color: ${p => select.color(["grey", p.selected ? 7 : 6], p)};
  padding: ${select.space(1)} ${select.space(3)};
  font-size: ${select.fontSize(-1)};
  cursor: ${p => (p.selected ? "default" : "pointer")};
  transition: ${select.speed("fast")};
  font-family: ${select.font("Lato")};
  background-color: ${p =>
    p.highlighted ? select.color(["grey", 0]) : "transparent"};

  &:hover {
    background-color: ${select.color(["grey", 0])};
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  selected?: boolean;
  highlighted?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
};

function SelectMenuItem(
  { style, className, selected, highlighted, children, ...rest }: Props,
  ref: any
) {
  return (
    <Base
      ref={ref}
      style={style}
      className={className}
      selected={selected!}
      highlighted={highlighted!}
      {...rest}
    >
      {children}
    </Base>
  );
}

export default React.forwardRef(SelectMenuItem);
